import React from "react";

import CircularProgress from "@material-ui/core/CircularProgress";
import logo from "../../assets/logo.png";

import { LoadingContainer } from "./styles";

const LoadingInicial = () => (
  <LoadingContainer>
    <div>
      <img src={logo} alt="logo"/>
      <CircularProgress color="inherit" />
    </div>
  </LoadingContainer>
);

export default LoadingInicial;
